module.exports = __webpack_public_path__ + "static/media/rlc.e627265e.svg";